import React, { FC } from 'react';
import Modal from 'react-modal';
import { routes } from 'appConstants';
import { Link } from 'components';
import iconClose from 'assets/img/cookie-v4/icon-close.svg';
import styles from './styles.module.scss';

const DOCS_BASE = `${process.env.PUBLIC_URL || ''}/docs`;
const USER_AGREEMENT_PDF = `${DOCS_BASE}/user-agreement.pdf`;
const PRIVACY_POLICY_PDF = `${DOCS_BASE}/privacy-policy.pdf`;

type Props = {
  isOpen: boolean,
  onClose?: () => void,
};

const SERVICE_LINKS = [
  {
    title: 'Продвижение',
    to: `${routes.resolutions.service.root}/buyer`,
  },
  {
    title: 'Оценка экспортного потенциала',
    to: routes.auth.exportTest.root,
  },
];

const PopupAccept: FC<Props> = ({
  isOpen,
  onClose = () => {},
}) => (
  <Modal
    isOpen={isOpen}
    ariaHideApp={false}
    className={styles.popup}
    closeTimeoutMS={300}
    onRequestClose={onClose}
    overlayClassName={styles.overlay}
    shouldCloseOnOverlayClick={false}
  >
    <div className={styles.head}>
      <h2 className={styles.title}>Мы используем файлы cookie</h2>
      <button
        type="button"
        className={styles.close}
        onClick={onClose}
        aria-label="Закрыть"
      >
        <img src={iconClose} alt="" width={22} height={22} />
      </button>
    </div>

    <p className={styles.text}>
      Для повышения удобства работы с сайтом, мы используем файлы cookie.
      Продолжая использовать наш сайт, Вы принимаете условия
      {' '}
      <a
        href={USER_AGREEMENT_PDF}
        className={styles.docLink}
        target="_blank"
        rel="noopener noreferrer"
      >
        Соглашения об условиях использования пользовательских данных посетителей сайта
      </a>
      {' '}
      и
      {' '}
      <a
        href={PRIVACY_POLICY_PDF}
        className={styles.docLink}
        target="_blank"
        rel="noopener noreferrer"
      >
        Согласие на обработку персональных данных
      </a>
      {' '}
      с помощью сервиса «Яндекс.Метрика». Если Вы не хотите, чтобы пользовательские данные
      обрабатывались, отключите cookie в настройках браузера
    </p>

    <ul className={styles.serviceLinks}>
      {SERVICE_LINKS.map((item) => (
        <li key={item.to}>
          <Link to={item.to} className={styles.serviceLink} onClick={onClose}>
            {item.title}
          </Link>
        </li>
      ))}
    </ul>
  </Modal>
);

export default PopupAccept;
